(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/bingo-react/assets/javascripts/pages/page-lobby.js') >= 0) return;  svs.modules.push('/modules/bingo-react/assets/javascripts/pages/page-lobby.js');
"use strict";


const {
  useEffect
} = React;
const WidgetArea = svs.components.lbUtils.widgetArea.WidgetArea;
const {
  StaticWidgetArea
} = svs.bingo_react.components.common.constants;
const {
  PageHeader
} = svs.bingo_react.components.page_header;
const {
  TickerPromoText
} = svs.bingo_react.components;
const {
  TickerWinners
} = svs.bingo_react.components;
const {
  showTickerPromoText
} = svs.bingo_react.data.tickerTextConfig;
const {
  showTickerPromoWinners
} = svs.bingo_react.data.tickerWinnersConfig;
const {
  BingoGrid
} = svs.bingo_react.components.bingoGrid;
const startBingoGame = svs.bingo_react.components.startBingoGame;
const bingoGameRooms = svs.bingo_react.data.bingoGameRooms;
const BingoLobby = _ref => {
  let {
    headerConfig
  } = _ref;
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const gameName = searchParams.get('autostart');
    const bingoGame = bingoGameRooms.find(game => game.title === gameName);
    if (bingoGame) {
      startBingoGame(bingoGame.id);
    }
  }, []);
  return React.createElement(React.Fragment, null, React.createElement("main", {
    className: "bingo-main-content-container"
  }, React.createElement(PageHeader, {
    fallbackConfig: {
      header: 'Vilken svensk klassiker väljer du?'
    },
    headerConfig: headerConfig
  }), showTickerPromoText && React.createElement(TickerPromoText, null), showTickerPromoWinners && React.createElement(TickerWinners, null), React.createElement(BingoGrid, null)), React.createElement("section", null, React.createElement(WidgetArea, {
    widgetArea: StaticWidgetArea.BingoLobby
  })));
};
setGlobal('svs.bingo_react.pages.BingoLobby', BingoLobby);

 })(window);